export default __webpack_public_path__ + "static/avatar-f4f73ef292fade70ee6de7cfe732007f.png";